import React, { FC, ReactElement } from 'react'

interface Props {
  path: any
  canton: 'VD' | 'GE'
  name: string
  category: string
  active: boolean
  colorMode: 'light' | 'dark'
  handleMapEvent: (event: any) => void
}
const Region: FC<Props> = ({
  path,
  canton,
  name,
  category,
  active = false,
  colorMode,
  handleMapEvent,
}): ReactElement => {
  const getColor = (category: string, active: boolean) => {
    if (active) {
      return canton === 'VD' ? '#d9010e' : '#D3343F'
    } else {
        return '#C8C8D1'
    }
  }
  return (
    <path
      className={`path ${active && 'active'}`}
      data-name={name}
      d={path}
      fill={getColor(category, active)}
      // fill={active ? '#D3343F' : '#69AACD'}
      opacity={0.8}
      strokeWidth={0.4}
      stroke={'#ffffff'}
      onClick={handleMapEvent}
      style={{ transition: 'fill 0.2s ease-out' }}
    />
  )
}

export default Region
